import 'tasks.v2.lib.task-notification';

import { ReplicationService } from './replication-service';

export const replicationService = new ReplicationService();
